import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import { ToastersService } from '../../../global/services/toasters.service';

@Component({
  selector: 'app-typeahead-multiselect',
  templateUrl: './typeahead-multiselect.component.html',
  styleUrls: ['./typeahead-multiselect.component.less'],
})
export class TypeaheadMultiselectComponent<T> implements OnChanges, AfterViewInit {
  @ViewChild('searchInput') searchInput: ElementRef;
  items: T[] = [];

  @Input() keyProperty?: keyof T;
  @Input() valueProperty: keyof T;
  @Input() customPlaceholderText: string;
  @Input() isSingleSelect = false;
  @Input() fetchItems: (search: string) => Promise<T[]>;

  selectedItemsKeys: T[keyof T][] = [];

  @Input() selectedItems: T[] = [];
  @Output() selectedItemsChanged = new EventEmitter<T[]>();

  search: string | T[keyof T];
  dropdownShown = false;
  selectedItemsDisplayValues: string[] = [];
  selectedItemsPreview: string;

  dropdownItems: Node[] = [];

  constructor(private toasters: ToastersService, private eRef: ElementRef, private cdr: ChangeDetectorRef) {}

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target) && !this.dropdownItems.includes(event.target)) {
      this.dropdownShown = false;
      this.search = '';
      this.getDisplayValues();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedItems) {
      this.getDisplayValues();
    }
  }

  ngAfterViewInit(): void {
    // This will be called once the view has been initialized
    if (this.dropdownShown && this.searchInput && this.searchInput.nativeElement) {
      this.searchInput.nativeElement.focus();
    }
  }

  async onSearchChange() {
    try {
      this.items = (await this.fetchItems(this.search as string)) || [];
    } catch (e) {
      this.toasters.createErrorToast('There was an error with your search, try again later.');
    }
  }

  async openDropdownOnClickAndFocusSearchInput() {
    if (this.dropdownShown) return;
    this.dropdownShown = true;
    await this.onSearchChange();
    this.cdr.detectChanges(); // Ensure the view updates before focusing
    if (this.searchInput && this.searchInput.nativeElement) {
      this.searchInput.nativeElement.focus();
    }
  }

  get unselectedItems() {
    if (this.keyProperty)
      return this.items.filter((i) => !this.selectedItems.some((s) => s[this.keyProperty] === i[this.keyProperty]));
    else return this.items.filter((i) => !this.selectedItems.some((s) => s === i));
  }

  unselectItem(item: T) {
    this.dropdownItems = Array.from(this.eRef.nativeElement.querySelector('.dropdown').children);
    if (this.keyProperty)
      this.selectedItems = this.selectedItems.filter((i) => i[this.keyProperty] !== item[this.keyProperty]);
    else this.selectedItems = this.selectedItems.filter((i) => i !== item);
    this.selectedItemsChanged.emit(this.selectedItems);
    this.getDisplayValues();
  }

  selectItem(item: T) {
    if (this.isSingleSelect) {
      this.selectedItems = [item];
    } else {
      this.dropdownItems = Array.from(this.eRef.nativeElement.querySelector('.dropdown').children);
      this.selectedItems.push(item);
    }
    this.selectedItemsChanged.emit(this.selectedItems);
    this.getDisplayValues();
  }

  getDisplayValues() {
    this.selectedItemsDisplayValues = this.selectedItems.map((item: any) => item[this.valueProperty]);
    this.setSelectedItemsPreviewString();
  }

  setSelectedItemsPreviewString() {
    if (this.selectedItemsDisplayValues.length > 1) {
      this.selectedItemsPreview = `${this.selectedItemsDisplayValues[0]} (+${
        this.selectedItemsDisplayValues.length - 1
      })`;
    } else {
      this.selectedItemsPreview = this.selectedItemsDisplayValues[0];
    }
  }
}
